import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { myFav } from "../../models";
import { ROOT } from "../../constants";
import closeImage from "../../images/close.png";

class WishListBox extends Component {
  removeItem = data => {
    const { channelCatalogItemCode } = data;
    this.props.removeFromMyFav(channelCatalogItemCode);
  };
  isWishList = itemCode => {
    const { wishListData } = this.props;
    if (wishListData) {
      const found = wishListData.wishListItems.findIndex(
        data => data.channelCatalogItemCode === itemCode
      );
      if (found !== -1) {
        return "active";
      } else {
        return "";
      }
    } else {
      return "";
    }
  };
  render() {
    const { getWishListSuccessfully, wishListData, scale } = this.props;
    return (
      <div>
        <div className="search-item-quantity">
          {getWishListSuccessfully && (
            <>
              <Translation>{t => <>{t("searchPage.foundtc")}</>}</Translation>
              {wishListData.wishListItems.length}
              {wishListData.wishListItems.length > 1 ? (
                <Translation>{t => <>{t("searchPage.items")}</>}</Translation>
              ) : (
                <Translation>{t => <>{t("searchPage.item")}</>}</Translation>
              )}
              <Translation>{t => <>{t("searchPage.found")}</>}</Translation>
            </>
          )}
        </div>

        <div className="products-result-wrap">
          {getWishListSuccessfully &&
          wishListData &&
          wishListData.wishListItems.length > 0 ? (
            <>
              {/* 成功取得，且商品大於一 */}
              {wishListData.wishListItems.map((data, index) => (
                <div
                  className={`product-result-box pdt_block 
                  ${scale ? "box-row" : ""}`}
                  key={index}
                >
                  <div className="box-content">
                    <div
                      className="remove-wish-list-btn wish-list-close-btn"
                      onClick={this.removeItem.bind(this, data)}
                    >
                      <img src={closeImage} alt="" />
                    </div>
                    <a href={`${ROOT}${data.productDetailUrl}`}>
                      <div
                        className="box-image"
                        style={{
                          backgroundImage: `url(${data.image2})`
                        }}
                      >
                        <img src={data.image1} alt="" />
                      </div>
                    </a>
                    <div className="color-options-wrap"></div>
                    <div className="desc_wrap">
                      <div className="collectionName">{data.productName1}</div>
                      <div className="name">{data.productName2}</div>
                      {data.discountPrice &&
                      data.origPrice !== data.discountPrice ? (
                        <>
                          <div className="originalPrice_wrap">
                            <div className="price">{data.origPrice}</div>
                          </div>
                          <div className="price">{data.discountPrice}</div>
                        </>
                      ) : (
                        <>
                          <div className="price">{data.origPrice}</div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              {/* 取得失敗，或是商品數為0 */}
              <div className="wish-list-error-content">
                <Translation>
                  {t => <>{t("wishListBag.wishListEmpty")}</>}
                </Translation>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    wishListData: state.myFav.wishListItems,
    getWishListSuccessfully: state.myFav.getWishListSuccessfully,
    scale: state.scaleProduct.scale
  };
};
const mapDispatchToProps = () => {
  return {
    removeFromMyFav: pdtId => myFav.actions.removeFromMyFav(pdtId)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WishListBox);
